import { TableBody } from '@mui/material';

import { FC } from 'react';
import { CustomTableRow } from './table-row';
import { Import, ImportType } from 'api/hooks/import/importType';

type Props = {
    data: Import[];
    importType: ImportType
};

export const CustomTableBody: FC<Props> = ({ data, importType }) => {
    return (
        <>
            <TableBody>
                {data.map((row) => {
                    return <CustomTableRow data={row} key={row._id} importType={importType} />;
                })}
            </TableBody>
        </>
    );
};
